import {type DefaultError, useMutation} from "@tanstack/react-query";
import {queryHttp} from "../../../query/queryHttp";
import {environment} from "../../../env";
import {CHAT_CONFIG} from "../services/ChatConfiguration";

export type RenameDashboardVariables = {
    dashboardId: number;
    title: string;
};

export type RenameDashboardResponse = {
    message: string;
};

/**
 * `PATCH /api/v1/superset/dashboards/{dashboard_id}/rename`
 * Body: `{ title: string }`.
 */
export function useRenameDashboardMutation() {
    return useMutation<RenameDashboardResponse, DefaultError, RenameDashboardVariables>({
        mutationFn: async ({dashboardId, title}) => {
            if (environment.isTestChat) {
                return {message: "Test mode: rename dashboard skipped"};
            }
            if (!CHAT_CONFIG.API_URL) {
                throw new Error("Chat API URL is not configured");
            }
            const {data} = await queryHttp.request<RenameDashboardResponse>({
                url: `${CHAT_CONFIG.API_URL}/superset/dashboards/${dashboardId}/rename`,
                method: "PATCH",
                data: {title},
            });
            return data;
        },
    });
}
